// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1TWep","infoBtn":"quickbooks_infoBtn__35q_3","formBox":"quickbooks_formBox__1Idza","formFooter":"quickbooks_formFooter__3laiI"};